import axios from 'axios';

class BaseAPI {
  callAPI(confix, headers, callback, callbackErr) {
    let config = {
      method: confix.method,
      url: confix.url,
      headers: headers ? headers : '',
      crossDomain: true
    };
    if (confix.body && confix.method !== 'get') {
      config = { ...config, data: confix.body };
    }
    const service = axios.create(config);
    service
      .request(config)
      .then(function(response) {
        callback(response.data);
      })
      .catch(error => {
        callbackErr(error);
      });
  }

  fetchConfig(confix, headers) {
    return new Promise((resolve) => { 
      let config = {
        method: confix.method,
        url: confix.url,
        headers: headers ? headers : '',
        crossDomain: true
      };
      if (confix.body && confix.method !== 'get') {
        config = { ...config, data: confix.body };
      }
      const service = axios.create(config);
      service
        .request(config)
        .then(function(response) {

          resolve(response.data);
          // callback(response.data);
        })
        .catch(error => {
          resolve(null);
        });
    
    });
  }
  
}

export default new BaseAPI();
